import React from 'react';
import MaterialsSection from 'components/quote_builder_widget/shared/MaterialsSection';

const CartonMaterialsSection = ({ onMaterialsChange }) => {
  return (
    <MaterialsSection
      materialType="carton_material"
      translationPrefix="carton"
      onMaterialsChange={onMaterialsChange}
    />
  );
};

export default CartonMaterialsSection;
